import { createApp } from "vue";
import { createStore } from "vuex";
import JiffyServicesPreview from "./JiffyServicesPreview.vue";
import "./jiffy-services-preview.scss";

export const initApp = (selector = "#jiffy-services-preview") => {
  const mountPoint = document.querySelector(selector);
  // eslint-disable-next-line no-underscore-dangle
  if (!mountPoint || mountPoint?.__vue_app__) return;

  const app = createApp({});
  app.component("JiffyServicesPreview", JiffyServicesPreview);
  // Mock store for standalone usage. When used within vue-cart, the component
  // inherits the real store. This mock provides required getters to prevent errors.
  app.use(
    createStore({
      state: {},
      getters: {
        experiments: () => ({}),
        showTransfersStoreCreditBanner: () => false
      },
      modules: {
        shipping: {
          namespaced: true,
          getters: {
            showBlanksFreeShippingBanner: () => false
          }
        }
      }
    })
  );
  app.mount(selector);
};

export default initApp;
